import { render, staticRenderFns } from "./ManageBar.vue?vue&type=template&id=024bfbe3&scoped=true"
import script from "./ManageBar.vue?vue&type=script&lang=js"
export * from "./ManageBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024bfbe3",
  null
  
)

export default component.exports